import { graphql } from "react-relay";

export const LEVEL_DEFINITION_FRAGMENT = graphql`
	fragment editLevelDefinitionButton_LevelDefinitionFragment on LevelDefinition {
		id
	}
`;
